import { enableProdMode, provideAppInitializer, inject, importProvidersFrom } from '@angular/core';

import { initializeApp } from './app/app.module';
import { environment } from './environments/environment';
import { Title, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { DilysuService } from './app/craidd/gwasanaethau/defnyddiwr/dilysu.service';
import { BlurService } from './app/craidd/gwasanaethau/system/blur.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { DiEnwPrime } from 'src/assets/steilio/di-enw-prime';
import { httpInterceptorProviders } from './app/craidd/rhyng-gipio';
import { ApiService } from './app/craidd/gwasanaethau/api/api.service';
import { IaithApiService } from './app/craidd/gwasanaethau/iaith/iaith-api.service';
import { StorfaDefnyddiwrService } from './app/craidd/gwasanaethau/system/storfa-defnyddiwr.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app/app-routing.module';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CwestiwnModule } from './app/modiwlau/cwestiwn/cwestiwn.module';
import { UiModule } from './app/modiwlau/ui/ui.module';
import { DilysuModule } from './app/modiwlau/dilysu/dilysu.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { IaithSystemService } from './app/craidd/gwasanaethau/iaith/iaith-system.service';
import { AppComponent } from './app/app.component';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, FormlyMaterialModule, CwestiwnModule, UiModule, DilysuModule, AppRoutingModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: IaithSystemService,
                deps: [IaithApiService, StorfaDefnyddiwrService],
            },
        })),
        // {
        //   provide: APP_INITIALIZER,
        //   multi: true,
        //   useFactory: initializeKeyboardBlur,
        //   deps: [BlurService],
        // },
        // provideAppInitializer(() => {
        //   const initializer = initializeApp(inject(DilysuService));
        //   return initializer();
        // }),
        provideAppInitializer(() => {
            initializeApp(inject(DilysuService));
        }),
        provideAppInitializer(() => {
            inject(BlurService);
        }),
        // Angen animations ar gyfer PrimeNG v20. Angen diweddaru i ng21 a PrimeNG v21 er mwyn tynnu'r isod
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: DiEnwPrime,
                options: {
                    darkModeSelector: false || "none",
                    cssLayer: { name: "app-theme", order: "primeng, app-theme" },
                },
            },
        }),
        httpInterceptorProviders,
        ApiService,
        IaithApiService,
        StorfaDefnyddiwrService,
        Title,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ]
})
    .catch(err => console.error(err));
